"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map = require("babel-runtime/core-js/map");

var _map2 = _interopRequireDefault(_map);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.sortObject = sortObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @description Sorts the elements of an object.
 * @summary
 * **About sorted Objects**
 *
 * It is important to note, that by design this method cannot return another Object:
 * Objects do not have any sorting. Any sorting that may exist in small objects is only due to specific browser
 * implementations. As per specifications Objects are unordered:
 *
 * > An object is a member of the type Object.
 * > It is an unordered collection of properties each of which contains a primitive value, object, or function.
 * - ECMA-262 Chapter 4.3.3
 * {@see http://www.ecma-international.org/publications/files/ECMA-ST-ARCH/ECMA-262,%203rd%20edition,%20December%201999.pdf}
 *
 * The new ES6 type Map() implements a HashMap that ensures property order.
 * However, not all frameworks and Libraries support ES6 Map() types.
 * For this reason it is possible to let this function return a 2 Dimensional Array instead.
 *
 * @example
 * import { sortObject } from '@nimius/object-utility'
 *
 * // Default sort: by keys ascending
 * const object = { b: 3, a: 1, c: 2 };
 * sortObject(object);
 * // => Map { a: 1, b: 3, c: 2 });
 *
 * @example
 * import { sortObject } from '@nimius/object-utility'
 *
 * // Custom sort: By value using array unpacking
 * const object = { b: 3, a: 1, c: 2 };
 * sortObject(object, ([keyA, valueA], [keyB, valueB]) => valueA - valueB);
 * // => Map { a: 1, c: 2, b: 3 }
 *
 * @example
 * import { sortObject } from '@nimius/object-utility'
 *
 * // Return array
 * const object = { b: 3, a: 1, c: 2 };
 * sortObject(object, ([keyA, valueA], [keyB, valueB]) => valueA - valueB, true);
 * // => [ ['a', 1], ['c', 2], ['b', 3] ]
 *
 * @param {Object} object - The Object that should be sorted
 * @param {function} [sortingMethod = null] - A custom sorting method that is compatible
 *        with `Array#sort` where both elements are arrays. The first element of
 *        each array corresponds to the key whereas the second element corresponds
 *        to the value. This is done to be compatible with the `Map` constructor
 *        and allow for easy array unpacking. If no sorting method is specified,
 *        then the Object is sorted by keys, ascending.
 * @param {boolean} [returnArray = false] - If set to true, then an array of the
 *        same form as above is returned, If it is set to false (default),
 *        then a Map is returned.
 * @returns {Map<any>|any[][]}
 */
function sortObject(object) {
    var sortingMethod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var returnArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


    // Default sorting method: By key ascending
    sortingMethod = sortingMethod || function (_ref, _ref2) {
        var _ref4 = (0, _slicedToArray3.default)(_ref, 1),
            keyA = _ref4[0];

        var _ref3 = (0, _slicedToArray3.default)(_ref2, 1),
            keyB = _ref3[0];

        return keyA > keyB;
    };

    // Build an array containing the keys and values of the object.
    // This is done, because arrays can be sorted.
    var sortedArray = (0, _keys2.default)(object).map(function (key) {
        return [key, object[key]];
    }).sort(sortingMethod);

    return returnArray ? sortedArray : new _map2.default(sortedArray);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/object-utility/src/sort-object.js
// module id = 70
// module chunks = 0 2